import { Image, Text, View } from "@react-pdf/renderer";
import styles from "./styles";
import { OpenEndedQuestionType } from "../types";
import { t } from "i18next";
import renderMarkdownText from "./markdownParseFunction";

type Props = {
  question: OpenEndedQuestionType;
  showAnswer: boolean;
  questionIndex: number;
};

export default function OpenEndedQuestion({
  question,
  showAnswer,
  questionIndex,
}: Props) {
  const { body, answer, point, image, mediaUrl, learningOutcome, explanation } =
    question;

  //body has explanation and question and the question is seperated by \n\n
  const splittedBody = body?.split("\n\n");

  let imageFile: string | Buffer | undefined;
  if (image && image.startsWith("data:image")) {
    const base64 = image.split(",")[1];
    const buff = Buffer.from(base64, "base64");
    imageFile = buff;
  } else if (image) {
    imageFile = image;
  } else if (mediaUrl) {
    imageFile = mediaUrl;
  }

  return (
    <View
      style={[styles.questionContainerH, { marginVertical: 4 }]}
      wrap={false}
    >
      <View style={styles.questionContainerV}>
        <Text style={styles.questionNumber}>{`${questionIndex + 1}. `}</Text>
        <View style={styles.questionContainerH}>
          {imageFile && <Image src={imageFile} style={styles.questionImage} />}
          <View style={styles.questionContainerV}>
            <Text style={styles.questionBody}>
              {renderMarkdownText(splittedBody?.[0])}
              {"\n"}
              <Text style={styles.questionNumber}>
                {"\n"}
                {renderMarkdownText(splittedBody?.[1])} ({point}{" "}
                {t("pdf_renderer.point")}){" "}
              </Text>
            </Text>
          </View>
          <View style={[styles.questionContainerH, { minHeight: 150 }]}>
            {showAnswer && answer && (
              <View style={styles.answerContainer}>
                <Text style={[styles.questionBody, styles.answerLabel]}>
                  {t("assignments.generator.preview.correctAnswer")}:
                </Text>
                <Text style={[styles.questionBody, styles.openEndedAnswer]}>
                  {renderMarkdownText(answer)}
                </Text>
              </View>
            )}
            {showAnswer && explanation && (
              <View style={styles.explanationContainer}>
                <Text style={[styles.questionBody, styles.explanationLabel]}>
                  {t("assignments.generator.preview.criteria")}:
                </Text>
                <Text style={[styles.questionBody, styles.explanation]}>
                  {renderMarkdownText(explanation)}
                </Text>
              </View>
            )}
          </View>
        </View>
      </View>
      {showAnswer && learningOutcome && (
        <Text style={[styles.answer, styles.questionBody]}>
          {t("pdf_renderer.outcome")}: {renderMarkdownText(learningOutcome)}
        </Text>
      )}
    </View>
  );
}
